import { render } from "./fugaohuli-news.vue?vue&type=template&id=6807af26&scoped=true"
import script from "./fugaohuli-news.vue?vue&type=script&lang=js"
export * from "./fugaohuli-news.vue?vue&type=script&lang=js"

import "./fugaohuli-news.vue?vue&type=style&index=0&id=6807af26&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6807af26"]])

export default __exports__